module.exports = __webpack_public_path__ + "static/media/feature-demo-3.ff4b84db.jpg";